import React from "react";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import styles from "@/components/modal/message-modal/styles/message-modal.module.scss";

type MessageModalProps = {
  title?: string;
  titleColor?: string;
  message?: string;
};

const MessageModal = ({ title, message, titleColor }: MessageModalProps) => {
  const { hideModal } = useGlobalModalContext();

  const modalTitle = title ?? "Something went wrong";
  const modalTitleColor = titleColor ?? "#E64C4C";

  return (
    <div className={styles.wrapper}>
      <div className={styles.header_wrapper}>
        <div className={styles.title} style={{ color: modalTitleColor }}>
          {modalTitle}
        </div>
        {message && <div className={styles.message}>{message}</div>}
      </div>
      <div className={styles.footer_wrapper}>
        <div className={styles.ok_button} onClick={hideModal}>
          Ok
        </div>
      </div>
    </div>
  );
};

export default MessageModal;
